import React, { memo, useState, useEffect, ChangeEvent } from 'react';
import closeImage from '@/assets/images/login/inp_close.png';
import luckImage from '@/assets/images/login/code.png';
import phoneImage from '@/assets/images/login/phone.png';
import checkRight from '@/assets/images/login/pwd_checked.png';
import { Form, Input, Button } from 'antd';
import { setUserInfo } from '@/store/module/user';
import classnames from 'classnames';
import useCount from '@/hooks/count';
import { useHistory } from 'react-router-dom';
import '../index.less';
import { getPhoneCodeProps, apiGetPhoneCode } from '../server';
import { isTel } from '@/utils';
import { connect } from 'react-redux';
import { IStoreState } from '@/store/types';
import Fn from '@/utils/fn';
import { lmessage } from '../message';
import Footer from '../components/footer';
import { loginCollect } from '@/views/login/collect/loginCollect';
const COUNT_STATIC = 60;

interface BindingPhoneProps {
  phoneData: any;
  phoneChange: (values: any) => void;
}

function LoginPhone(props: BindingPhoneProps) {
  const { phoneData, phoneChange } = props;
  const [form] = Form.useForm();
  const history: any = useHistory();
  const [mobile, setMobile] = useState<string>('');
  const [count, beginTimer, closeTimer] = useCount(COUNT_STATIC);
  const [canLogin, setCanLogin] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [phoneText, setPhoneText] = useState<string>('');

  useEffect(() => {
    loginCollect(3000, 1);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  function onTimerClick() {
    loginCollect(3002, 2);
    form.validateFields().then(async val => {
      const values = val as getPhoneCodeProps;
      if (isTel(values.phone) || true) {
        let res: any = await apiGetPhoneCode({ phone: values.phone, event: 1, type: 'login' });
        if (!res.code) res = res.data;
        if (res.code === 200) {
          setIsChecked(true);
          setPhoneText(Fn.phoneEncrypt(values.phone));
          lmessage.success('发送成功');
          beginTimer();
        } else {
          if (res.msg) lmessage.error(res.msg);
        }
      }
    });
  }
  const onPhoneBlur = () => {
    const formData = form.getFieldsValue();
    if (formData.phone && !isTel(formData.phone)) {
      lmessage.error('手机号格式错误');
    }
  };
  function changeStatus() {
    const formData = form.getFieldsValue();
    if (formData.phone && isTel(formData.phone) && formData.code) {
      return setCanLogin(true);
    }
    setCanLogin(false);
  }
  const handlePercentMatchPhone = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const val = value ? value.replace(/[\D]/g, '') : value;
    form.setFieldsValue({
      phone: val
    });
    setMobile(val);
    changeStatus();
  };
  const handlePercentMatchCode = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const val = value ? value.replace(/[\D]/g, '') : value;
    form.setFieldsValue({
      code: val
    });
    changeStatus();
  };
  function formSubmit() {
    loginCollect(3004, 2);
    const formData = form.getFieldsValue();
    // if (!formData.policy) {
    //   return lmessage.error('请勾选同意《用户授权协议》、《隐私条款》');
    // }
    if (formData.phone && isTel(formData.phone) && formData.code) {
      phoneChange(formData);
      // setIsChecked(false);
    }
  }

  useEffect(
    () => () => {
      closeTimer();
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  useEffect(() => {
    if (phoneData.phone) {
      changeLoginHistory(phoneData);
      setMobile(phoneData.phone);
      if (phoneData.code) {
        changeStatus();
      }
    }
  }, [form]); // eslint-disable-line react-hooks/exhaustive-deps
  const changeLoginHistory = (data: any) => {
    let formData = form.getFieldsValue();
    formData.phone = data.phone;
    formData.code = data.code;
    form.setFieldsValue({ ...formData });
  };
  const onGoBack = () => {
    history.replace('/login/account');
    loginCollect(3006, 2);
  };
  const focus = () => {
    loginCollect(3001, 3);
  };
  const getFocus = () => {
    loginCollect(3003, 3);
  };
  return (
    <>
      <div className="login-switch_mold">
        <div
          onClick={e => {
            e.stopPropagation();
            onGoBack();
          }}
        >
          账号登录
        </div>
        <div className="separate"></div>
        <div className="currnt">短信登录</div>
      </div>
      <div className="login-form_box" id="login_drop">
        <Form form={form} onFinish={formSubmit} autoComplete="off">
          <Form.Item name="phone">
            <Input
              placeholder="请输入手机号"
              onChange={(e: ChangeEvent<HTMLInputElement>) => handlePercentMatchPhone(e)}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
              prefix={<img src={phoneImage} className="phone_icon" alt="" />}
              onBlur={() => onPhoneBlur()}
              onFocus={() => focus()}
            ></Input>
          </Form.Item>
          <div className="login_code_box">
            <Form.Item name="code" className="check_out_box" style={{ marginBottom: '0px' }}>
              <Input
                className="check_input"
                placeholder="验证码"
                allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
                prefix={<img src={luckImage} className="phone_icon" alt="" />}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handlePercentMatchCode(e)}
                onFocus={() => getFocus()}
                maxLength={4}
              ></Input>
            </Form.Item>
            <Button
              onClick={onTimerClick}
              htmlType="button"
              type="text"
              disabled={COUNT_STATIC !== count || !isTel(mobile)}
              className={classnames('check_inline_text checkbox_text active phone_login_code codebox_text', {
                codebox_active_text: isTel(form.getFieldsValue().phone) || count !== COUNT_STATIC
              })}
            >
              {count === COUNT_STATIC ? '获取验证码' : `${count}秒后重发`}
            </Button>
          </div>
          <div className="check_tips check_tips_text" style={{ visibility: isChecked ? 'visible' : 'hidden' }}>
            <img src={checkRight} className="check_icon" alt="" />
            <span className="check_text">已发送4位验证码至 {phoneText}</span>
          </div>
          <Button
            htmlType="submit"
            className={canLogin ? 'login-form_box__submit_button' : 'login-form_box__submit_button disabled'}
          >
            登录
          </Button>
        </Form>
      </div>
      <Footer agreementType={1}></Footer>
    </>
  );
}
export default connect(({ settings }: IStoreState) => ({ settings }), {
  setUserInfo
})(memo(LoginPhone));
